import { useState, useEffect } from 'react';
import { EventSourcePolyfill } from 'event-source-polyfill';

export function useEventSource(token, isAuthenticated) {
    const [listOfUsers, setListOfUsers] = useState([]);
    const [listOfAvailableVehicles, setListOfAvailableVehicles] = useState([]);
    const [isBackendConnected, setBackendConnected] = useState(false);

    useEffect(() => {
        if(isAuthenticated && token) {
            const listeners = [
                { event: 'listOfUsers', callback: onListOfUsers },
                { event: 'listOfAvailableVehicles', callback: onListOfAvailableVehicles },
                { event: 'open', callback: onOpen },
                { event: 'error', callback: onError },
            ];

            function onListOfUsers(event) {
                setListOfUsers(JSON.parse(event.data))
            }

            function onListOfAvailableVehicles(event) {
                setListOfAvailableVehicles(JSON.parse(event.data))
            }

            function onError(event) {
                console.error(`Error in server sent event source:`);
                console.error(event);
                setBackendConnected(false);
            }

            function onOpen(event) {
                console.log(`Server sent event source opened.`);
                console.log(event);
                setBackendConnected(true);
            }

            try {
                const server = `${process.env.REACT_APP_BACKEND_URL}:${process.env.REACT_APP_BACKEND_PORT}`;
                const eventSource = new EventSourcePolyfill(`${server}/presence-events`, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                listeners.forEach((listener) => {
                    eventSource.addEventListener(listener.event, listener.callback);
                });

                return () => {
                    listeners.forEach((callback) => {
                        eventSource.removeEventListener(callback.event, listeners.callback);
                    });
                    eventSource.close();
                    setBackendConnected(false);
                };
            } catch (error) {
                console.error(`Error while connecting with server sent event source: ${error}`);
                setBackendConnected(false);
            }
        }
    }, [token, isAuthenticated]);

    return { isBackendConnected, listOfUsers, listOfAvailableVehicles };
}
